import React, { useState } from 'react'

/**
 * @param {{ sections: { title: string, body: React.ReactNode }[], idPrefix?: string }} props
 */
export default function LegalAccordion({ sections, idPrefix = 'legal' }) {
  const [openIndex, setOpenIndex] = useState(null)

  const toggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index))
  }

  return (
    <div className="legal-accordion" role="list">
      {sections.map((section, index) => {
        const isOpen = openIndex === index
        const panelId = `${idPrefix}-panel-${index}`
        const headerId = `${idPrefix}-header-${index}`

        return (
          <div
            key={section.title}
            role="listitem"
            className={`legal-accordion-item${isOpen ? ' legal-accordion-item--open' : ''}`}
          >
            <button
              type="button"
              id={headerId}
              className="legal-accordion-question"
              aria-expanded={isOpen}
              aria-controls={panelId}
              onClick={() => toggle(index)}
            >
              <span className="legal-accordion-question-text">{section.title}</span>
              <span className="legal-accordion-chevron" aria-hidden="true" />
            </button>
            <div
              id={panelId}
              role="region"
              aria-labelledby={headerId}
              className="legal-accordion-answer-wrap"
              hidden={!isOpen}
            >
              <div className="legal-accordion-answer">{section.body}</div>
            </div>
          </div>
        )
      })}
    </div>
  )
}
